import Logger from "../clients/sentry";
import { serializeErrorForWarning } from "../errors";

export interface Region {
  id: string;
  name: string;
  deleted_at: string | null;
  created_at: string;
  updated_at: string;
  category: string;
  category_label?: string;
  cost_index?: number;
  primary_cost_region?: boolean;
}

export interface RegionEscalation {
  region: string;
  multiplier: number;
}

export interface EscalationData {
  primaryRegionId: string;
  escalationByRegionId: Record<string, RegionEscalation>;
}

export const applyEscalationData = (escalationData: EscalationData, regions: Region[]): Region[] => {
  try {
    return regions.map((region) => {
      const escalation = escalationData.escalationByRegionId[region.id];

      return {
        ...region,
        cost_index: escalation ? escalation.multiplier : undefined,
        primary_cost_region: region.id === escalationData.primaryRegionId,
      };
    });
  } catch (error) {
    Logger.warn("Error applying escalation data", serializeErrorForWarning(error));
    return regions;
  }
};
